/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";

import { shallowEqual, useSelector } from "react-redux";
import { permissionCheck } from "../../utils/permission";
import { useHistory } from "react-router-dom";
import Clients from "../../components/Client/Clients";


const ClientList = () => {
  const history = useHistory();
  const { permissions } = useSelector((store) => ({
    previewClient: store.Client.previewClient,
    permissions: store.Profile.permissions,
  }), shallowEqual);
  const [activeTab, setActiveTab] = useState("");

  const [targetPermission, setTargetPermission] = useState(null);

  // const _setActiveTab = (value) => {
  //   history.push(`/client/${value}`);
  // };

  // const tabList = [
  //   {
  //     label: (
  //       <>
  //         거래처 관리 <small className="color-red-100 font-size-10">new</small>
  //       </>
  //     ),
  //     action: _setActiveTab,
  //     value: "list",
  //   },
  //   {
  //     label: (
  //       <>
  //         거래처 그룹 관리 <small className="color-red-100 font-size-10">new</small>
  //       </>
  //     ),
  //     action: _setActiveTab,
  //     value: "categories",
  //   },
  // ];

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find((p) => p.code === "COMPANY_ACCOUNT");
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "COMPANY_ACCOUNT");
      }
    }
  }, [permissions]);

  useEffect(() => {
    setActiveTab(history.location?.pathname.split('client/')[1]);
  }, [history.location]);


  return (
    !isEmpty(targetPermission) && (
      <>
        {activeTab === "list" && <Clients targetPermission={targetPermission}
        // tabList={tabList} activeTab={activeTab} 
        />}
      </>
    )
  );
};

export default ClientList;
